import React from "react";
import "./Activitse.css";
import LiveChatActivity from "./LiveChatActivity";
import LoadingSkeleton from "./LoadingSkeleton";

const ActivitiesContent = (props) => {
  return (
    <>
      <div className="row mt-3">
        {props.loader ? (
          props.event.map((event) => {
            return (
              <>
                <LiveChatActivity
                  event={event.live_chat}
                  eventData={event}
                  event_type="livechat"
                  room_id={event.live_chat?.room_id}
                ></LiveChatActivity>
              </>
            );
          })
        ) : (
          <LoadingSkeleton />
        )}
      </div>
    </>
  );
};

export default ActivitiesContent;
